define('modules/editor/views/editors/video',['require','exports','module','common/views/modal_view','cm/lib/codemirror','ldsh!../../templates/editors/video'],function(require, exports, module){
	"use strict";
	var BaseView = require("common/views/modal_view"),
			CodeMirror = require("cm/lib/codemirror");

	module.exports = BaseView.extend({
		template: require("ldsh!../../templates/editors/video"),

		events: {
			"click .js-save": "saveEditorContent",
			"shown.bs.modal": "initEditor"
		},

		initialize: function(options) {
			this.editorContent = (options.content || "<! -- EMBED VIDEO CODE -->").trim();
		},

		helpers: function(){
			return {
				content: this.editorContent
			};
		},

		getEditorContent: function() {
			return this.codeEditor.getValue();
		},

		saveEditorContent: function(e) {
			e.preventDefault();
			this.trigger("modal:save", this.codeEditor.getValue());
		},

		initEditor: function() {
			var editorDomElement = document.getElementById("videoEditor");
			this.codeEditor = CodeMirror.fromTextArea(editorDomElement, {
				mode: "htmlmixed",
				lineNumbers: true,
				autofocus: true,
				lineWrapping: true
			});
		}
	});
});

